/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_AiInputs */

const en_common_ai = /** @type {(inputs: Common_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI`)
};

const es_common_ai = /** @type {(inputs: Common_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IA`)
};

/**
* | output |
* | --- |
* | "AI" |
*
* @param {Common_AiInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_ai = /** @type {((inputs?: Common_AiInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_AiInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_ai(inputs)
	return en_common_ai(inputs)
});